var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdaptation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_350_484)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 1,
    width: 48,
    height: 48,
    rx: 10,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 1.5,
    width: 47,
    height: 47,
    rx: 9.5,
    stroke: "#EAECF0",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0001 26.3001C25.8701 26.3001 25.7401 26.2701 25.6201 26.2001L16.7901 21.0901C16.4401 20.8801 16.3101 20.4201 16.5201 20.0601C16.7301 19.7001 17.1901 19.5801 17.5501 19.7901L26.0001 24.6801L34.4001 19.8201C34.7601 19.6101 35.2201 19.7401 35.4301 20.0901C35.6401 20.4501 35.5101 20.9101 35.1601 21.1201L26.3901 26.2001C26.2601 26.2601 26.1301 26.3001 26.0001 26.3001Z",
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26 35.36C25.59 35.36 25.25 35.02 25.25 34.61V25.54C25.25 25.13 25.59 24.79 26 24.79C26.41 24.79 26.75 25.13 26.75 25.54V34.61C26.75 35.02 26.41 35.36 26 35.36Z",
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0001 35.75C25.1201 35.75 24.2501 35.56 23.5601 35.18L18.2201 32.21C16.7701 31.41 15.6401 29.48 15.6401 27.82V22.17C15.6401 20.51 16.7701 18.59 18.2201 17.78L23.5601 14.82C24.9301 14.06 27.0701 14.06 28.4401 14.82L33.7801 17.79C35.2301 18.59 36.3601 20.52 36.3601 22.18V27.83C36.3601 29.49 35.2301 31.41 33.7801 32.22L28.4401 35.18C27.7501 35.56 26.8801 35.75 26.0001 35.75ZM26.0001 15.75C25.3701 15.75 24.7501 15.88 24.2901 16.13L18.9501 19.1C17.9901 19.63 17.1401 21.07 17.1401 22.17V27.82C17.1401 28.92 17.9901 30.36 18.9501 30.9L24.2901 33.87C25.2001 34.38 26.8001 34.38 27.7101 33.87L33.0501 30.9C34.0101 30.36 34.8601 28.93 34.8601 27.82V22.17C34.8601 21.07 34.0101 19.63 33.0501 19.09L27.7101 16.12C27.2501 15.88 26.6301 15.75 26.0001 15.75Z",
    fill: "#292D32"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_350_484",
    x: 0,
    y: 0,
    width: 52,
    height: 52,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_350_484"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_350_484",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdaptation);
export default __webpack_public_path__ + "static/media/adaptation.b6a86ea62ba12d639ce58c4879e4a329.svg";
export { ForwardRef as ReactComponent };